module.exports = __webpack_public_path__ + "img/54_34.4277d2a4.png";